import React from "react";

const bannerStyle = {
  background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
  borderRadius: "1rem",
  padding: "1.5rem 2rem",
  margin: "1rem 0",
  cursor: "pointer",
  transition: "all 0.3s ease",
  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
  color: "white",
};

const titleStyle = {
  fontSize: "1.1rem",
  fontWeight: "700",
  marginBottom: "0.5rem",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
};

const ctaStyle = {
  display: "inline-block",
  marginTop: "1rem",
  padding: "0.5rem 1.5rem",
  background: "rgba(255,255,255,0.2)",
  borderRadius: "0.5rem",
  fontWeight: "600",
  fontSize: "0.85rem",
  border: "1px solid rgba(255,255,255,0.3)",
};

const IntervendBanner = () => {
  return (
    <div
      style={bannerStyle}
      onClick={() => window.open("https://web.intervend.rs", "_blank")}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "none";
        e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.1)";
      }}
    >
      <h3 style={titleStyle}>Isprobaj novi interfejs za praćenje prometa i statusa mašina — Intervend</h3>
      <span style={ctaStyle}>Pogledaj →</span>
    </div>
  );
};

export default IntervendBanner;
